// src/v2/locations/LocationNavPair.jsx
//
// OFFICE-OVERVIEW-CLEANUP: Pill-button Prev/Next pair for the Office detail
// unified bar — fixed 104px width, "‹ Prev" / "Next ›" text only, no sub-label.
// Mirrors the PrevNextPager pill style used by the office drawer.
//
// Props:
//   prevLabel — display name of the previous location; null/undefined at list start
//   nextLabel — display name of the next location; null/undefined at list end
//   onPrev    — () => void called when Prev is clicked; undefined at start
//   onNext    — () => void called when Next is clicked; undefined at end
//
// Returns null when both prevLabel and nextLabel are null/undefined (no list available,
// e.g. direct URL entry with a single-item portfolio).
// At list boundaries one side is disabled in place — no layout shift.
// Right-alignment is handled at the DetailUnifiedBar rightSlot container level,
// not inside this component.

import React from "react";
import { T } from "../../app/tokens.js";
import { HairlineNavButton } from "../../components/HairlineNavButton.jsx";

export function LocationNavPair({ prevLabel, nextLabel, onPrev, onNext }) {
  if (prevLabel == null && nextLabel == null && !onPrev && !onNext) return null;

  return (
    <div
      data-testid="location-detail-pager"
      style={{
        display:    "inline-flex",
        alignItems: "center",
        gap:         6,
        paddingLeft: 14,
        borderLeft:  `1px solid ${T.planCompBorder}`,
      }}
    >
      <HairlineNavButton
        label="‹ Prev"
        onClick={onPrev}
        testId="location-prev-button"
        disabled={!onPrev}
        titleText={prevLabel ? `Previous: ${prevLabel}` : undefined}
      />
      <HairlineNavButton
        label="Next ›"
        onClick={onNext}
        testId="location-next-button"
        disabled={!onNext}
        titleText={nextLabel ? `Next: ${nextLabel}` : undefined}
      />
    </div>
  );
}
